import PathwayTemplate from './component'
export default PathwayTemplate
